<template>
    <b-container fluid class="mt--7">
        <list-items v-if="isList" title="Master Items" ref="table">
            <b-button-group class="float-right">
                <b-button
                    variant="primary"
                    v-if="user_permissions.includes('create.master.items')"                  
                    :to="`${$route.path}/0`"
                    >Add Master Item</b-button
                >
                <b-button
                    variant="primary"
                    @click="exportMasterItems()"
                    v-show="user_permissions.includes('view.master.items')"
                    >Export Master Items</b-button
                >
            </b-button-group>
        </list-items>
        <view-item @success="alertSuccess" :id="id" v-else></view-item>
    </b-container>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import popupMixins from '@/mixins/popupMixins'

import showItemHelper from '@/mixins/showItemHelper'

export default {
    name: 'MasterItem',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, showItemHelper],
    data: () => {
        return {
            item: null,
        }
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('assets/listVendors')
    },
    computed: {
        items() {
            const items = this.$store.state.masterItem.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        alertSuccess(message) {
            this.doToast('Success', message, 'success')
        },
        exportMasterItems() {
            this.$refs.table.showDetailsDialog()
        },
    },
}
</script>
<style></style>
